<template>
  <div>
    <component
      v-for="(app,index) in comps"
      :is="app"
      :key="index"
    ></component>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      comps: ["Wp_page_test", "Wp_page_test"],
      apps: []
    };
  },
  created() {
    this.comps.forEach(app => {
      this.apps.push({ app: require(`../pages/${app}.vue`) });
    });
  }
};
</script>